import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import './nodeConfig.less';

interface ReusableModalProps {
  title?: String;
  renderContent?: any;
  customFooter: any[];
  onOk?: () => void;
  onCancel?: () => void;
  showModal: boolean;
  className?: string;
}

const ReusableModal: React.FC<ReusableModalProps> = (props: any) => {
  const {
    showModal, title, renderContent, customFooter, onCancel, onOk, className,
  } = props;
  const [open, setOpen] = useState(showModal);
  const { t } = useTranslation();

  useEffect(() => {
    setOpen(showModal);
  }, [showModal]);

  const handleOk = () => {
    setOpen(false);
    if (onOk) onOk();
  };

  const handleCancel = () => {
    setOpen(false);
    if (onCancel) onCancel();
  };

  return (
    <Modal
      open={open}
      title={<div className="text-center font-bold">{t(title)}</div>}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={customFooter}
      className={`flexible-modal-${className}`}
      centered
    >
      {renderContent}
    </Modal>
  );
};

ReusableModal.defaultProps = {
  title: '',
  showModal: true,
};

export default ReusableModal;
